import styles from './Style.module.css'
import EditIcon from "../Icons/EditIcon";

export const SaleNote = ({ saleNote, showAddNotePopup }) => {
  return (
    <div className={`${styles.noteContainer}`}>
      <label>Notes:</label>
      <p>{saleNote}</p>
      {typeof showAddNotePopup === 'function' ? (
        <button type="button" className={`${styles.editNoteIconbtn} icon`} onClick={showAddNotePopup}>
          <EditIcon />
        </button>
      ) : null}
    </div>
  );
};
